import routerOptions0 from "/home/node/apps/claimant-portal-ui/app/router.options.ts";
import routerOptions1 from "/home/node/apps/claimant-portal-ui/node_modules/.pnpm/nuxt@3.5.3_ib6n3u26orgsw3ddu5c2ar5ipm/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions1,
...routerOptions0,
}